import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { Box } from '@influitive/secret-garden/lib/flex';
import Heading from '@influitive/secret-garden/lib/heading';
import Paragraph from '@influitive/secret-garden/lib/paragraph';
import Input from '@influitive/secret-garden/lib/form-inputs/input';
import Sortable from '@influitive/secret-garden/lib/sortable';
import * as R from 'ramda';
import { themeGet } from 'styled-system';
import { Global, css } from '@emotion/core';

import { buildErrorMessage } from '../util';
import Context from '../context';
import { setRequiredBadges, setLevelName, setLevels } from '../actions';

const StyledItem = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${themeGet('spacing.1')}px;

`;

const LevelIndex = styled.div`
  text-align: center;
  width: ${themeGet('spacing.3')}px;
  padding-right: ${themeGet('spacing.2')}px;
`;

const SortableElement = ({ value, index }) =>
  <StyledItem>
    <div>{value}</div>
    <LevelIndex>{R.inc(index)}</LevelIndex>
  </StyledItem>;

const LevelNameInput = styled(Input)`
  width: 330px;
`;

const LevelName = styled.label`
  margin-bottom: ${themeGet('spacing.3')}px;
`;

const RequiredBadgesInput = styled(Input)`
  input {
    width: ${themeGet('spacing.7')}px;
  } `
;

const sortableItemStyles = css`
  .activeSortableItem {
    z-index: 1501;
  }
`;

export default ({ level, levels, errors }) => {
  const { dispatch } = useContext(Context);

  return <React.Fragment>
    <Heading level={4}>
      Edit Level Details
    </Heading>

    <Paragraph>
      Fill out details for your new level. It can be changed after it's created.
    </Paragraph>

    <LevelName>
      <LevelNameInput
        label='Level name'
        id='level_name'
        name='name'
        value={level.name}
        type='text'
        required={true}
        hasError={R.not(R.isNil(errors.name))}
        errorMessage={buildErrorMessage(errors.name)}
        onChange={e => dispatch(setLevelName(e.target.value))} />
    </LevelName>

    <Box width={300}>
      <div>Level order</div>

      <Global styles={sortableItemStyles} />
      <Sortable
        items={levels}
        lockAxis='y'
        onChange={R.compose(dispatch, setLevels)}
        hasBorder={true}
        helperClass={'activeSortableItem'}
        disabledItems={[0]}>
        {levels.map((level, i) =>
          <SortableElement
            key={level.uuid || 'newLevel'}
            value={level.name}
            index={i} />
        )}
      </Sortable>

      {R.and(level.id, level['allows-badges']) && <Box mb={3}>
        <RequiredBadgesInput
          id='required-badge-count'
          label='Badges required for this level'
          name='required_badge_count'
          value={level.required_badge_count}
          type='text'
          required={true}
          hasError={R.not(R.isNil(errors.required_badge_count))}
          errorMessage={buildErrorMessage(errors.required_badge_count)}
          maxLength={3}
          onChange={e => dispatch(setRequiredBadges(e.target.value))} />
      </Box>}
    </Box>
  </React.Fragment>;
};
